import OfferUpdate from "./OfferUpdate";

export default OfferUpdate;